<template>
  <div>
    <br />
    <div class="row justify-content-end">
      <div class="col-auto">
        <button @click="referesh()" class="btn btn-secondary">
          <i class="bi bi-plus-circle"></i>
          Actualiser
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-xl-3 col-12 my-3">
        <label for=""> Référence </label>
        <div>
          {{ sellerPayment.reference }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Référence Vente Vendeur</label>
        <div>
          {{ sellerPayment.seller_sale_reference }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Référence Paiement</label>
        <div>
          {{ sellerPayment.payment_reference }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Montant</label>
        <div>
          {{ sellerPayment.amount }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Date</label>
        <div>
          {{ sellerPayment.date }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Montant Restant</label>
        <div>
          {{ sellerPayment.remainingAmount }}
        </div>
      </div>

      <div class="col-xl-12 col-12 my-3">
        <label for=""> Remarque </label>
        <div>
          {{ sellerPayment.remark }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters("sellerPayment", {
      sellerPayment: "getSellerPayment",
    }),
  },
  methods: {
    async referesh() {
      await this.$store.dispatch(
        "sellerPayment/show",
        this.$route.params.reference
      );
    },
  },
  beforeMount() {
    this.$store.dispatch("sellerPayment/show", this.$route.params.reference);
  },
};
</script>
